/**
 * I-1 — o aviso das listas de configuração diz o que aconteceu.
 *
 * Antes, todo `catch` das listas chutava a mesma frase: "(nome duplicado?)".
 * O chute mandou o Matheus procurar um serviço repetido que não existia — e
 * não podia existir, porque `catalogo_servicos` não tem índice único em
 * `nome`. O erro real era um 400: faltava o campo `tipo` no payload.
 *
 * Erro que manda a pessoa procurar o que ela não pode ver é pior que erro
 * nenhum. Aqui a mensagem sai do status que o servidor devolveu, e o caso de
 * duplicidade só aparece quando o servidor de fato diz 409.
 *
 * Regra 15 do projeto: formulário nunca é surdo.
 */
import { ApiError } from '@/lib/api';

export function mensagemErroConfig(err: unknown, duplicado: string): string {
  if (!(err instanceof ApiError)) {
    return 'Não foi possível salvar agora. Confira a conexão e tente de novo.';
  }
  switch (err.status) {
    case 400:
      return 'Faltou preencher algum campo. Confira o formulário e tente de novo.';
    case 403:
      return 'Você não tem permissão para mudar esta lista.';
    case 404:
      return 'Este item não existe mais. Atualize a página.';
    case 409:
      return duplicado;
    default:
      return 'Não foi possível salvar agora. Tente de novo.';
  }
}
